import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ChangeEvent, ReactNode } from "react";

interface SharedMUIListProps {
  lable: string;
  value: string;
  onChange: (value: string) => void;
  list: string[];
  width?: string | "150px"; //This means witdth can be any string or 150px, its not default value
  required?: boolean;
  defaultValue?: string | " ";
}
export const SharedMUIList = ({ lable, value, list, onChange, width = "150px", required, defaultValue }: SharedMUIListProps) => {
  console.log("SharedMUIList lable: " + lable + "Relation " + value + " required: " + required);
  function handleOnChange(
    e: ChangeEvent<Omit<HTMLInputElement, "value"> & { value: string }> | (Event & { target: { value: string; name: string } }),
    child: ReactNode
  ): void {
    onChange(e.target.value);
  }

  return (
    <FormControl size="small" sx={{ width: width }} required={required}>
      <InputLabel
        id="shared-select-label"
        shrink={true} // 👈 Force shrink to prevent overlap
      >
        {lable}
      </InputLabel>
      <Select labelId="shared-select-label" id="shared-select" label={lable} value={value} onChange={handleOnChange}>
        {list.map((listValue: string) => (
          <MenuItem value={listValue} key={listValue}>
            {listValue}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
